import { SxProps } from "@mui/material";

export const sxTable: SxProps = {
  borderRadius: '10px',
  width: '100%',
  '@media (max-width: 1135px)': {
      width: '60vw'
  },
  '@media (max-width: 1055px)': {
      width: '55vw'
  },
  '@media (max-width: 920px)': {
      width: '50vw'
  },
  '@media (max-width: 899px)': {
      width: '90vw'
  },
  '@media (max-width: 425px)': {
      width: '85vw'
  }
}